import React from 'react';

const InfoWindow = () => (
  <div id="info-window" className="tsla-twotip">
    <div className="tsla-twotip__body" />
  </div>
);

export default InfoWindow;
